// eslint-disable-next-line import/no-anonymous-default-export
export default (num, targetLength) => {
  return num.toString().padStart(targetLength, '0');
};
